<template>
    <div>
      <Architectures></Architectures>
    </div>
</template>

<script>

import Architectures from "./components/Architectures";

export default {
  data() {
    return {
    };
  },
  components: {
    Architectures

  },
  methods: {
  },
};
</script>

<style>

</style>